import React from 'react';
import AddToCart from '../AddToCart/AddToCart';
import { getSrc } from 'gatsby-plugin-image';
import * as styles from './Product.module.scss';
import ReactMarkdown from 'react-markdown';

const Product = ({ product, cmsData }) => {
  const productShot = getSrc(product.images[0]);
  const price = product?.variants[0]?.price;

  if (!cmsData) {
    return <div>Loading...</div>;
  }

  console.log('CREATING PRODUCT SUCCESS:', '[', product.title, ']');

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageWrapper}>
        <img src={productShot} alt="Product image" />
        <div className={styles.addToCartContainerMobile}>
          <AddToCart product={product} />
        </div>
      </div>

      <div className={styles.informationWrapper}>
        <h1 className={styles.productTitle}>{product.title}</h1>
        <p className={styles.productDetails}>{product.productType}, {product.options[0]?.values[0]}</p>
        <p className={styles.productPrice}>€{price}</p>
        <ReactMarkdown className={styles.cmsInfoText}>
          {cmsData.information}
        </ReactMarkdown>
        <div className={styles.addToCartContainer}>
          <AddToCart product={product} />
        </div>
      </div>

      <section>
        {cmsData.content?.map((section, index) => {
          switch (section.type) {
            case 'fullImage':
              return (
                <div className={styles.doubleImageWrap} key={index}>
                  <img className={styles.fullImage} src={getSrc(section.fullImage)} alt="" />
                </div>
              );
            case 'image':
              return (
                <div className={styles.singleImageWrap} key={index}>
                  <img src={getSrc(section.image)} alt="" />
                </div>
              );
            case 'windowText':
              return (
                <ReactMarkdown className={styles.windowText} key={index}>
                  {section.windowText}
                </ReactMarkdown>
              );
            case 'fullText':
              return (
                <ReactMarkdown className={styles.fullText} key={index}>
                  {section.fullText}
                </ReactMarkdown>
              );
            default:
              return <div key={index}>Data type not recognized</div>;
          }
        })}
      </section>

      <div className={styles.bottomSection}>
        <ReactMarkdown className={styles.windowText}>
          {cmsData.productWindowText}
        </ReactMarkdown>
        {cmsData.contentBottom?.map((img, index) => {
          const imgSrc = getSrc(img.image);
          return (
            <div className={styles.bottomProductCMSImage} key={index}>
              <img src={imgSrc} alt="" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Product;
